import React from "react";
import RoundedProfilePicture from "../profile-picture/rounded-profile-picture.comonent";

interface Account {
  displayName: string;
  profilePictureResource?: {
    url: string;
  };
}

interface OverlappingProfilesProps {
  collaborators: Account[];
  maxVisible?: number;
  size?: number;
}

const OverlappingProfiles: React.FC<OverlappingProfilesProps> = ({
  collaborators,
  maxVisible = 3,
  size = 44,
}) => {
  const displayedCollaborators = collaborators.slice(0, maxVisible);
  const overflowCount = collaborators.length - maxVisible;

  return (
    <div className="flex items-center">
      {displayedCollaborators.map((collaborator, index) => (
        <div
          key={index}
          className="relative"
          style={{ marginLeft: index !== 0 ? "-10px" : "0" }}
        >
          <div className="border border-blue-500 rounded-full overflow-hidden">
            <RoundedProfilePicture url={collaborator.profilePictureResource?.url} name={collaborator.displayName} size={size} />
          </div>
        </div>
      ))}
      {overflowCount > 0 && (
        <div className="h-10 w-10 -ml-2 rounded-full bg-gray-300 flex justify-center items-center text-xs font-semibold">
          +{overflowCount}
        </div>
      )}
    </div>
  );
};

export default OverlappingProfiles;
